import Flatpickr from 'flatpickr/dist/flatpickr';
import moment from 'moment';

angular.module('am4').directive('ngFlatpickr', function($rootScope, errorService, $parse, $q, flatpickrTranslationLoader) {
    return {
        restrict : 'A',
        link : (scope, element, attrs) => {
            let fpOpts = $parse(attrs.fpOpts)(scope),
                fpOnSetup = $parse(attrs.fpOnSetup),
                flatPickrl10n = $q.defer(),
                now = new Date();

            fpOpts.defaultDate = $parse(attrs.ngModel)(scope);

            // Enable 12-hr time for computers using it
            if (now.toLocaleTimeString().match(/am|pm/i) || now.toString().match(/am|pm/i) ) {
                fpOpts.time_24hr = false;
                fpOpts.altFormat = fpOpts.altFormat12hr;
            }

            if ($rootScope.lang === 'en') {
                flatPickrl10n.resolve();
            } else {
                // Need to get translation asset from server
                flatPickrl10n.resolve(flatpickrTranslationLoader($rootScope.lang));
            }

            flatPickrl10n.promise.then(flatPickrl10nAsset => {
                if (flatPickrl10nAsset) {
                    fpOpts.locale = flatPickrl10nAsset[$rootScope.lang];
                } // else, English will be displayed
            })
            .finally(() => {

                /**
                 * Date Formatting
                 * @param  {String} format - pattern with which to format the date as a string (https://chmln.github.io/flatpickr/formatting/)
                 * @param {Date} dateObj - a javascript Date object
                 * @returns {String}
                */
                fpOpts.formatDate = (format, dateObj) => {
                    let chars = format.split(''),
                        flatpickrFormats = Flatpickr.prototype.formats,

                        // Adapted from flatpickr source
                        dateString = chars.map(function(c, i) {
                            if (flatpickrFormats[c] && chars[i - 1] !== '\\') {
                                return flatpickrFormats[c](dateObj);
                            }
                            return c !== '\\' ? c : '';
                        }).join('');

                    // Custom functionality to support designated timezones
                    // input/model value returns UTC value of a date-time selected in the designated timezone
                    if (fpOpts.timezone) {
                        let timezone = fpOpts.timezone || 'UTC';
                        if (format === fpOpts.dateFormat) {
                            // If we are formatting the input/model value:
                            // We ignore the dateString generated above and convert the dateObj to UTC time
                            let utcMoment = moment.utc(dateObj)
                                            // The above conversion assumes dateObj is in the browser's timezone
                                            // and will subtract the browser's utcOffset from the date-time.
                                            // We reverse this by adding back the browser's utcOffset in minutes
                                            .add(moment(dateObj).utcOffset(), 'minutes'),

                            // We now have the selected date-time as if it were selected in UTC
                            // What we actually want is the selected date-time as if it were selected in fpOpts.timezone
                            // To simulate this, we subtract that timezone's utcOffset in minutes
                            // And we return this adjusted UTC value
                            // Later, if we were to display this UTC value in the relevant timezone, the subtracted minutes would be restored
                                timezoneOffset = angular.copy(utcMoment).tz(timezone).utcOffset();
                            utcMoment = utcMoment.subtract(timezoneOffset, 'minutes');
                            return utcMoment.format(); // e.g. "2017-03-27T04:00:00.000Z"

                        } else if (format === fpOpts.altFormat) {
                            // If we are formatting the input element's display value:
                            // We'll keep the dateString as-is, then append the appropriate timezone abbreviation
                            let utcMoment = moment.utc(dateObj) // Convert the dateObj to UTC time
                                            // Add the browser's utcOffset in minutes
                                            .add(moment(dateObj).utcOffset(), 'minutes'),
                                timezoneOffset = angular.copy(utcMoment).tz(timezone).utcOffset(),
                                timezoneAbbr = utcMoment
                                            // Subtract facility timezone's utcOffset in minutes
                                            .subtract(timezoneOffset, 'minutes')
                                            // Convert to facility timezone, which adds back the minutes from above
                                            .tz(timezone)
                                            // Format simply as 'z' to get the timezone abbreviation
                                            // Depending on the date-time resulting from the above adjustments,
                                            // this abbreviation may or may not be the daylight savings time version of the timezone abbreviation
                                            .format('z');

                            return dateString + ' ' + timezoneAbbr;
                        }
                        return dateString;
                    }
                    return dateString;
                };

                let flatPickr = new Flatpickr(element[0], fpOpts);

                if (fpOnSetup) {
                    fpOnSetup(scope, {
                        fpItem : flatPickr
                    });
                }

                return flatPickr;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/flatPickr.js